export default __webpack_public_path__ + "static/media/General Instructions.eb76c33c.pdf";